import React from 'react'
import { useTranslation } from 'react-i18next'
import TransitPreviewSection from './TransitPreviewSection'

interface TransitPreviewAuditSectionProps {
  auditReason: string
}

function TransitPreviewAuditSection(props: Readonly<TransitPreviewAuditSectionProps>) {
  const { t } = useTranslation()
  const { auditReason } = props

  return (
    <TransitPreviewSection
      columnId="audit"
      headingLabel={t('audit.declinationReason')}
    >
      <div className="col-12">
        <div className="px-2 text-danger">{auditReason}</div>
      </div>
    </TransitPreviewSection>
  )
}

export default TransitPreviewAuditSection
